import { BatchRunsTable } from '../components/BatchRunsTable';
import { LiveScansTable } from '../components/LiveScansTable';

/**
 * Interior Live Scans page — identical content to lightning's
 * ``LiveScansPage`` (``web/src/pages/LiveScansPage.tsx``): the active
 * batch runs panel sits above the live scans table, and both
 * components self-manage their 3-second polling. Keeping the layout
 * symmetric lets users switch between the lightning and interior tabs
 * without any visual cognitive load.
 */
export function InteriorLiveScansPage() {
  return (
    <div className="space-y-6">
      <BatchRunsTable />
      <LiveScansTable />
    </div>
  );
}
